import VueYoutube from "vue-youtube"
import VueVimeoPlayer from "vue-vimeo-player"
import VueMeta from "vue-meta"
import validator from "./validator.js"
import fontawesome from "./fontawesome.js"
import loading from "./loading.js"
import "vue-progress-path/dist/vue-progress-path.css"
import VueProgress from "vue-progress-path"
import Croppa from "vue-croppa"
import "vue-croppa/dist/vue-croppa.css"
import RequestReloadModal from "./request-reload.js"

export default Vue => {
  Vue.use(VueMeta)
  Vue.use(VueYoutube)
  Vue.use(VueVimeoPlayer)
  Vue.use(VueProgress)
  Vue.use(Croppa)
  validator(Vue)
  fontawesome(Vue)
  loading(Vue)
  RequestReloadModal(Vue)
}
